import {React, useState} from 'react';
import '../../App.css'
import {Grid, TextField, Box, Button, Paper,Typography} from '@mui/material';
import {SocialDistance} from '@mui/icons-material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const initialFValues={
  id: 0,
  fromDate: '',
  toDate: '',
}

function SeparationRateReport(){
  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validate = () => {
    let temp = {}
    // temp.month = values.month.length != 0 ? "" : "This field is required."
    // temp.year = values.year.length != 0 ? "" : "This field is required."

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }


  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    })
  }

  const handleSubmit =async (e) => {
    e.preventDefault();
    if(validate()) {
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/report/seperation-rate-details`, values)
      .then((response=>{
      // setEmpDetails(response.data);
      navigate('/seperation-report', {state: {seperationRateDetails: response.data, duration: {fromDate: values.fromDate, toDate: values.toDate}}});
    }))
    .catch((error)=>{
    })
    }
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px"}}>
      <Paper elevation={5} sx={{width: "1000px",height: "210px"}}>
        <Grid className="form-title" container spacing={2} justifyContent="center"style={{marginTop: "15px"}} alignItems="center">
          <Grid item> <SocialDistance sx={{width: 45, height: 45}}/> </Grid>
          <Grid item> <Typography variant="h5">Seperation Rate Report</Typography> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>

          <Box sx={{margin: "30px"}}>
            {/* All elements in one line */}
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              flexWrap: 'wrap'
            }}>
              
              {/* From Date field */}
              <TextField
                variant="outlined"
                className="date-picker"
                type="date"
                id="date-picker"
                label="From"
                name="fromDate"
                defaultValue="2017-05-24"
                value={values.fromDate}
                onChange={handleInputChange}
                sx={{ width: '200px' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              {/* To Date field */}
              <TextField
                variant="outlined"
                className="date-picker"
                type="date"
                id="date-picker"
                label="To"
                name="toDate"
                defaultValue="2017-05-24"
                value={values.toDate}
                onChange={handleInputChange}
                sx={{ width: '200px' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              {/* Display button */}
              <Button 
                className="form-btn" 
                color="success" 
                variant="contained" 
                type="submit"
                sx={{ height: 40 }}
              >
                Display
              </Button>
            </Box>
          </Box>
        </form>

      </Paper>
    </Box>
  )
}

export default SeparationRateReport;